import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@rcs.rpc`,
    services: {
        use_headless: {
            parameters: []
        },
        load_path: {
            parameters: [
                {
                    name: 'rest',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'hostname',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'urischeme',
                    type: 'string',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
